import React, { useState } from "react";
import { Link } from 'react-router-dom';
import classNames from "classnames";
import Menu from './Menu';
import { useTheme } from "../../context/theme";
import SidebarToggle from "./SidebarToggle";
import { MdMenu, MdOutlineLogout } from "react-icons/md";
import { useTranslation } from 'react-i18next';

const Sidebar = ({ mobile, visibility, setVisibility, compact, setCompact, onLogout }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const [mouseEnter, setMouseEnter] = useState(false);

    const handleMouseEnter = () => setMouseEnter(true);
    const handleMouseLeave = () => setMouseEnter(false);

    const classes = classNames({
        "nk-sidebar group/sidebar peer fixed left-0 top-0 z-[1031] flex flex-col w-[260px] [&.is-compact:not(.has-hover)]:w-[72px] h-[100dvh] max-h-[100dvh] overflow-hidden transition-[transform,width] duration-300 ease-out -translate-x-full xl:translate-x-0 [&.sidebar-visible]:translate-x-0 bg-[#1D2C7B] text-white border-r border-white/10": true,
        "sidebar-visible": visibility,
        "nk-sidebar-mobile": mobile,
        "is-compact": compact,
        "has-hover": compact && mouseEnter,
        dark: theme.sidebar === "dark",
    });

    return (
        <>
            <div className={classes}>
                <div className="flex items-center justify-between w-full h-14 shrink-0 border-b border-white/10 bg-[#1D2C7B] px-3 overflow-hidden group-[&.is-compact:not(.has-hover)]/sidebar:justify-center group-[&.is-compact:not(.has-hover)]/sidebar:px-2">
                    <div className="shrink-0 group-[&.is-compact:not(.has-hover)]/sidebar:mx-auto">
                        <div className="hidden xl:block">
                            <button
                                type="button"
                                onClick={() => setCompact(!compact)}
                                className="inline-flex items-center justify-center w-9 h-9 rounded-lg text-white/75 hover:bg-white/10 hover:text-white transition-colors"
                                aria-label="Panel"
                            >
                                <MdMenu className="text-xl" />
                            </button>
                        </div>
                        <div className="xl:hidden">
                            <SidebarToggle icon="arrow-left" onClick={() => setVisibility(!visibility)} />
                        </div>
                    </div>
                    <Link
                        to="/"
                        className="relative flex items-center min-w-0 group-[&.is-compact:not(.has-hover)]/sidebar:hidden"
                    >
                        <img className="h-8 w-auto shrink-0" src="/white.svg" alt="Logo" />
                    </Link>
                </div>

                <div
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    className="nk-sidebar-body flex flex-col flex-1 min-h-0 overflow-hidden bg-[#1D2C7B]"
                >
                    <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden overscroll-contain nk-sidebar-scroll px-1.5 pt-2 pb-2 group-[&.is-compact:not(.has-hover)]/sidebar:px-1">
                        <Menu setSidebarVisibility={setVisibility} />
                    </div>

                    {onLogout && (
                        <div className="shrink-0 p-2 border-t border-white/10 bg-[#1D2C7B] group-[&.is-compact:not(.has-hover)]/sidebar:px-1.5">
                            <button
                                type="button"
                                onClick={onLogout}
                                className="w-full flex items-center gap-2.5 rounded-lg px-2.5 py-2 text-[13px] font-medium text-white/80 hover:bg-white/10 hover:text-white transition-colors group-[&.is-compact:not(.has-hover)]/sidebar:justify-center group-[&.is-compact:not(.has-hover)]/sidebar:px-2"
                            >
                                <MdOutlineLogout className="text-lg shrink-0" />
                                <span className="group-[&.is-compact:not(.has-hover)]/sidebar:hidden whitespace-nowrap">
                                    {t('common.logout')}
                                </span>
                            </button>
                        </div>
                    )}
                </div>
            </div>
            <div
                onClick={() => setVisibility(false)}
                className="sidebar-toggle fixed inset-0 bg-slate-900/40 backdrop-blur-[2px] z-[1030] opacity-0 invisible peer-[.sidebar-visible]:opacity-100 peer-[.sidebar-visible]:visible xl:!opacity-0 xl:!invisible transition-opacity"
                aria-hidden
            />
        </>
    );
};

export default Sidebar;
